import React from 'react';
import { useLocation } from 'react-router-dom';

import googleAnalytics from '../lib/google_analytics';

export default function useGoogleAnalytics() {
  const location = useLocation();

  React.useEffect(() => {
    googleAnalytics.init();
  }, []);

  React.useEffect(() => {
    const currentPath = location.pathname + location.search;
    googleAnalytics.sendPageview(currentPath);
  }, [location]);
}
